import { iframeReplace } from 'core/iframe';
import { CONFIG } from 'config';

export function MatchesIndex(props) {
    iframeReplace(CONFIG.appLinks.matchmaking, '/home')();
    return null;
}
export default MatchesIndex;